import type { FC } from 'react';
import type { TFunction } from 'i18next';
import type { Control, FieldErrors } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { Flex, Form } from 'antd';
import TextArea from 'antd/es/input/TextArea';

import type { UpdateFormValues } from '@modules/ai-agent/lib/types';
import { Text } from '@shared/ui/antd';

import styles from '../../prompt.module.scss';

interface RecommendationsProps {
  control: Control<UpdateFormValues>;
  errors: FieldErrors<UpdateFormValues>;
  isLoading: boolean;
  t: TFunction<'translation', 'prompt'>;
}

export const Recommendations: FC<RecommendationsProps> = ({ control, errors, isLoading, t }) => (
  <Flex vertical className={styles.element} gap={16}>
    <Flex gap={4} align="start" vertical>
      <Text variant="md" fontWeight={500}>
        {t('recommendations.title')}
      </Text>

      <Text variant="sm" style={{ color: 'var(--color-text-tertiary)' }}>
        {t('recommendations.description')}
      </Text>
    </Flex>

    <Form.Item
      name="recommendations"
      help={errors.recommendations?.message}
      validateStatus={errors.recommendations ? 'error' : ''}
      className={styles.label}
    >
      <Controller
        control={control}
        name="recommendations"
        render={({ field }) => (
          <TextArea
            {...field}
            id="recommendations"
            placeholder={t('recommendations.placeholder')}
            className={styles.area}
            style={{ resize: 'none' }}
            showCount
            autoSize={{ minRows: 3 }}
            disabled={isLoading}
          />
        )}
      />
    </Form.Item>
  </Flex>
);
